import { render, staticRenderFns } from "./ChatTab.vue?vue&type=template&id=ede86de6&"
import script from "./ChatTab.vue?vue&type=script&lang=js&"
export * from "./ChatTab.vue?vue&type=script&lang=js&"
import style0 from "./ChatTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports